import { Box, CardMedia, IconButton } from "@mui/material";
import { Typography, Card, CardContent } from "./styled";
import React from "react";
import { UserProfileCardProps } from "./types";
import { useRouter } from "next/router";
import { User } from "../../UserProfile/types";
import CloseIcon from "@mui/icons-material/Close";

import { getUserDisplayNameAbbrev } from "@js/util/addressUtils";
import UserStatus from "@js/components/common/userstatus/UserStatus";
import { getGravatarDefaultIcon, handleImageUrlError } from "@js/util/urlUtil";

const UserProfileCard = (props: UserProfileCardProps) => {
    const router = useRouter();
    const user: User = props.user;

    /**
     * handleGoToUserProfile handle history state to render /user/:userId page
     */
    const handleGoToUserProfile = () => {
        return router.push(`/user/${user.address}`);
    };

    //Show mentor display if the property is present
    function mentorDisplay() {
        if (!user.mentor) {
            return <></>;
        }
        return (
            <Box display="flex" mb={0.5}>
                <UserStatus mentor={user.mentor} />
            </Box>
        );
    }

    /**
     * Handles removing user profile cards if function property is passed
     */
    const handleClose = () => {
        if (props.handleClose) {
            props.handleClose(user);
        }
    };

    return (
        <Card
            sx={{
                cursor: props.handleClose ? "default" : "pointer",
                position: "relative",
            }}
            elevation={1}
            onClick={props.handleClose ? () => {} : handleGoToUserProfile}
        >
            <IconButton
                onClick={handleClose}
                sx={{
                    display: props.handleClose ? "inline-flex" : "none",
                    position: "absolute",
                    right: "0px",
                    top: "0px",
                }}
            >
                <CloseIcon />
            </IconButton>
            <CardMedia
                component="img"
                height="60px"
                sx={{ width: "60px", padding: 1 }}
                src={getGravatarDefaultIcon(user.address)}
                onError={handleImageUrlError}
            />
            <CardContent>
                {mentorDisplay()}
                <Typography fontSize="20px" variant="body2">
                    {getUserDisplayNameAbbrev(user)}
                </Typography>
            </CardContent>
        </Card>
    );
};
export default UserProfileCard;
